// extracted by mini-css-extract-plugin
module.exports = {"multiScene":"MultiScene_multiScene__CxFAY"};